import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function BroadbandAddon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.163 7.74a5.926 5.926 0 015.92 5.92l-.002.201.002.07v7.662a1 1 0 01-1 1H2.013a1 1 0 01-1-1v-7.662a1 1 0 011-1h4.823v-.932a1 1 0 012 0v.932h2.453a5.927 5.927 0 015.874-5.19zm-5.781 7.191H3.013v5.662h18.07v-2.5a5.896 5.896 0 01-3.92 1.487 5.929 5.929 0 01-5.781-4.649zm5.781-5.19a3.923 3.923 0 00-3.919 3.919 3.924 3.924 0 003.92 3.92 3.924 3.924 0 003.92-3.92 3.924 3.924 0 00-3.92-3.92zm0 .844a1 1 0 011 1v1.065h1.067a1 1 0 010 2h-1.067v1.067a1 1 0 01-2 0V14.65h-1.065a1 1 0 110-2h1.065v-1.065a1 1 0 011-1zM7.836 7.869a4.19 4.19 0 013.19 1.472.999.999 0 11-1.52 1.298c-.825-.965-2.465-.982-3.309-.033a.999.999 0 11-1.494-1.329 4.2 4.2 0 013.133-1.408zm0-2.934A7.1 7.1 0 0112.7 6.854a1.001 1.001 0 01-1.366 1.462 5.103 5.103 0 00-3.496-1.381 5.11 5.11 0 00-3.455 1.343A1 1 0 113.032 6.8a7.108 7.108 0 014.805-1.866zM7.838 2c2.4 0 4.723.862 6.545 2.425a1 1 0 01-1.303 1.518A8.051 8.051 0 007.837 4a8.065 8.065 0 00-5.192 1.899.999.999 0 11-1.29-1.528A10.065 10.065 0 017.837 2z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoBroadbandAddon = React.memo(BroadbandAddon);
export default MemoBroadbandAddon;